'use strict';

import React from 'react';

require('styles//DpsRaion.css');
let png1 = require('../images/dps31.gif');

class DpsRaionComponent extends React.Component {
  render() {
    return (
    <div className="dpsraion-component">
        <h3 className="h3">Основные показатели здоровья населения и деятельности организаций здравоохранения Республики Казахстан с 2000 года по настоящее время</h3>
<p>On Line версия:<br/><a href="http://dps.medinfo.kz/" target="new" ><img src={png1} className="png1"/><div className="strOnline">Основные показатели здоровья населения и деятельности организаций здравоохранения РК</div></a></p>
<p className="pOfline">Off Line версия:
  <table className="dataTable">
  <tr><th>Файл</th><th>Размер</th><th>Дата последнего изменения</th></tr>
  <tr><td><a href="dpsfiles/DPS_2000_2018_RU.zip"><b>DPS_2000_2018_RU.zip русская версия(2000-2018 годы)</b></a></td><td>3 392 кБ</td><td>16.11.2019</td></tr>
  <tr><td><a href="dpsfiles/DPS_2000_2018_EN.zip"><b>DPS_2000_2018_EN.zip англ. версия (2000-2018 годы)</b></a></td><td>2 370  кБ</td><td>16.11.2019</td></tr>
  <tr><td colSpan="3">Скопируйте и разархивируйте файл <font color="green"><b>"DPS_2000_2013.zip"</b></font> на на свой компьютер в какую-нибудь папку (например C:&#92;DPS). Запускаемый файл <font color="green"><b>"DPS2.exe"</b></font>. Инструкция  по применению <font color="green"><b>"Инструкция DPS(region).doc"</b></font>.</td></tr></table>
</p>
      </div>
    );
  }
}

DpsRaionComponent.displayName = 'DpsRaionComponent';

// Uncomment properties you need
// DpsRaionComponent.propTypes = {};
// DpsRaionComponent.defaultProps = {};

export default DpsRaionComponent;



// WEBPACK FOOTER //
// ./src/components/DpsRaionComponent.js